import { render, staticRenderFns } from "./PositionRecommendMark.vue?vue&type=template&id=58dc2f11&scoped=true&"
import script from "./PositionRecommendMark.vue?vue&type=script&lang=js&"
export * from "./PositionRecommendMark.vue?vue&type=script&lang=js&"
import style0 from "./PositionRecommendMark.vue?vue&type=style&index=0&id=58dc2f11&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58dc2f11",
  null
  
)

export default component.exports